import { Chip, Stack, useTheme } from '@mui/material';
import { FC } from 'react';

type PriorityCheckListProps = Readonly<{
	value: readonly string[];
	onChange(newStatuses: readonly string[]): void;
	size: 'medium' | 'small';
}>;

export const prioritiesOptions = ['low', 'medium', 'high'] as const;

export const PriorityCheckList: FC<PriorityCheckListProps> = ({ value, onChange, size }) => {
	const theme = useTheme();
	const priorities = prioritiesOptions;
	const selectedPriorities = value.filter((id) => priorities.some((o) => o === id));

	return (
		<Stack direction={'row'} gap={1}>
			{priorities.map((priority) => (
				<Chip
					key={priority}
					label={priority[0].toUpperCase() + priority.slice(1)}
					variant={'outlined'}
					size={size}
					sx={{
						backgroundColor: theme.palette.secondary.lighter,
						borderColor: selectedPriorities.includes(priority) ? theme.palette.primary[400] : theme.palette.secondary[400],
						opacity: selectedPriorities.includes(priority) ? 1 : 0.5,
					}}
					onClick={() =>
						selectedPriorities.includes(priority)
							? onChange(selectedPriorities.filter((pId) => pId !== priority))
							: onChange(selectedPriorities.concat(priority))
					}
				/>
			))}
		</Stack>
	);
};
